/**
 * Style Utils
 */

const StyleUtils = {
  /**
   * Lighten or Darken color (hex value) a certain percentage
   * @param {String} color Example color: '#F61152'
   * @param {String} percent [-1:1]
   * @return {String} result: #000000
   */  
  // lightenDarkenColor: function(color, percent) {
  //   var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
  //   return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
  // },
  lightenDarkenColor: function(color, percent) {
    let col = color;
    let amt = percent * 100;

    var usePound = false;
    
    if (col[0] == "#") {
      col = col.slice(1);
      usePound = true;
    }
  
    var num = parseInt(col, 16);
  
    var r = (num >> 16) + amt;
  
    if (r > 255) r = 255;
    else if  (r < 0) r = 0;
  
    var b = ((num >> 8) & 0x00FF) + amt;
  
    if (b > 255) b = 255;
    else if  (b < 0) b = 0;
  
    var g = (num & 0x0000FF) + amt;
  
    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    return (usePound ? "#" : "") + String("000000" + (g | (b << 8) | (r << 16)).toString(16)).slice(-6);
  },
  /**
   * Fade color (hex value) a given percentage
   * @param {String} color Example color: '#F61152'
   * @param {String} percent [-1:1]
   * @return {String} result: rgba(0,0,0,0)
   */
  fadeColor: function(color, percent) {
    let rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    rgb = rgb ? {
        r: parseInt(rgb[1], 16),
        g: parseInt(rgb[2], 16),
        b: parseInt(rgb[3], 16)
    } : { r: '255', g: '255', b: '255' };
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${percent})`;
  }
};

export default StyleUtils;


// WEBPACK FOOTER //
// ./app/js/components/utils/StyleUtils.js